<template>
  <div class="page-heading header-text">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h1>Contact Us</h1>
          <span>feel free to send us a message now!</span>
        </div>
      </div>
    </div>
  </div>
  <div class="contact-information">
    <div class="container">
      <div class="d-flex justify-content-around">
        <div class="col-md-4">
          <div class="contact-item">
            <i class="fa fa-phone"></i>
            <h4>Phone</h4>
            <p>
              We're Just a Call Away. Reach Out
            </p>
            <a href="#">+92 300 844 9698</a>
          </div>
        </div>
        <div class="col-md-4">
          <div class="contact-item">
            <i class="fa fa-envelope"></i>
            <h4>Email</h4>
            <p>
              Feel free to drop us a note anytime!
            </p>
            <a href="#">imran@dtech.pk</a>
          </div>
        </div>
        <!-- <div class="col-md-4">
          <div class="contact-item">
            <i class="fa fa-map-marker"></i>
            <h4>Location</h4>
            <p>1020 New Mountain Street<br />Forest Park, FP 11220</p>
            <a href="#">View on Google Maps</a>
          </div>
        </div> -->
      </div>
    </div>
  </div>
  <div class="callback-form contact-us">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="section-heading">
            <h2>Send us a <em>message</em></h2>
            <span>Send us a message and we’ll get back to you as soon as possible.</span>
          </div>
        </div>
        <div class="col-md-12">
          <div class="contact-form">
            <form id="contact" ref="form" @submit.prevent="submitForm">
              <div class="row">
                <div class="col-lg-4 col-md-12 col-sm-12">
                  <fieldset>
                    <input
                      name="name"
                      type="text"
                      class="form-control"
                      id="name"
                      placeholder="Full Name"
                      required=""
                    />
                  </fieldset>
                </div>
                <div class="col-lg-4 col-md-12 col-sm-12">
                  <fieldset>
                    <input
                      name="email"
                      type="text"
                      class="form-control"
                      id="email"
                      pattern="[^ @]*@[^ @]*"
                      placeholder="E-Mail Address"
                      required=""
                    />
                  </fieldset>
                </div>
                <div class="col-lg-4 col-md-12 col-sm-12">
                  <fieldset>
                    <input
                      name="subject"
                      type="text"
                      class="form-control"
                      id="subject"
                      placeholder="Subject"
                      required=""
                    />
                  </fieldset>
                </div>
                <div class="col-lg-12">
                  <fieldset>
                    <textarea
                      name="message"
                      rows="6"
                      class="form-control"
                      id="message"
                      placeholder="Your Message"
                      required=""
                    ></textarea>
                  </fieldset>
                </div>
                <div class="col-lg-12">
                  <fieldset>
                    <button
                      type="submit"
                      id="form-submit"
                      class="filled-button"
                    >
                      Send Message
                    </button>
                  </fieldset>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        v-if="showMessage"
        class="alert mt-4"
        :class="{ 'alert-primary': !formError, 'alert-danger': formError }"
      >
        {{ resultMessage }}
      </div>
    </div>
  </div>
  <!-- <div id="map">
     How to change your own map point
	1. Go to Google Maps
	2. Click on your location point
	3. Click "Share" and choose "Embed map" tab
	4. Copy only URL and paste it within the src="" field below

    <iframe
      src="https://maps.google.com/maps?q=Av.+Lúcio+Costa,+Rio+de+Janeiro+-+RJ,+Brazil&t=&z=13&ie=UTF8&iwloc=&output=embed"
      width="100%"
      height="500px"
      frameborder="0"
      style="border: 0"
      allowfullscreen
    ></iframe>
  </div> -->
</template>

<script>
import formMixin from '../mixins/fromMixin';
export default {
  name: "ContactView",
  mixins: [formMixin],
};
</script>
